module.exports = __webpack_public_path__ + "img/81.1e2ec195.jpg";